import List from '../components/fruitstore/list/List';
export default function ListPage() {
  return <List />;
}
